// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_63136e', '__Inter_Fallback_63136e'","fontStyle":"normal"},"className":"__className_63136e","variable":"__variable_63136e"};